export default __webpack_public_path__ + "static/media/p1.fce61ee5.JPG";